<template>
    <v-app class="app">
      <v-snackbar
        v-model="store.snackbar.visible"
        :color="store.snackbar.color || undefined"
        :bottom="store.snackbar.bottom !== false"
        :timeout="store.snackbar.timeout"
        :multi-line="Boolean(store.snackbar.icon)"
        dark
      >
        <div class="d-flex align-center">
          <v-icon v-if="store.snackbar.icon" color="white" class="mr-2" size="20">
            {{ store.snackbar.icon }}
          </v-icon>
          <span style="white-space: pre-line">{{ store.snackbar.text }}</span>
        </div>
        <template v-slot:actions>
          <v-btn text color="white" @click="store.snackbar.visible = false"> Cerrar </v-btn>
        </template>
      </v-snackbar>
      <settings-modal></settings-modal>
      <notifications-drawer></notifications-drawer>
      <drawer-filter-right></drawer-filter-right>
      <upload-status-panel></upload-status-panel>
      <v-sheet color="secondary">
        <router-view></router-view>
      </v-sheet>
      <!-- General container drawer  -->
      <container-drawer v-if="store.currentForm || store.currentFormDialog"
      :drawerWidth="store.currentFormDialog === 'form-upload-supplies'
      || store.currentFormDialog === 'form-upload-trucks'
      || store.currentFormDialog === 'equipment-document-form'
      || store.currentFormDialog === 'equipment-document-type-manager'
      || store.currentFormDialog === 'form-truck-coupled'
      || store.currentFormDialog === 'form-truck-brand'
      || store.currentFormDialog === 'form-truck-type'
      || store.currentFormDialog === 'form-center-cost'
      || store.currentFormDialog === 'client-faena-manager'
      || store.currentFormDialog === 'form-rental-contract-equipment'
      || store.currentFormDialog === 'form-rental-contract-document'
      || store.currentFormDialog === 'form-rental-contract-checklist'
      || store.currentFormDialog === 'rental-checklist-question-manager'
      || store.currentFormDialog === 'form-specialist-type'
      || store.currentFormDialog === 'form-rental-delivery-checklist-answer' ? 500
      : store.currentFormDialog === 'rental-contract-quick-view' ? 820 : 400">

        <template #container>
          <PermissionGate :any-of="['maintenance_alerts.alerts.create', 'maintenance_alerts.alerts.update']">
            <side-bar-create-alert v-if="store.currentFormDialog === 'form-alert'">
            </side-bar-create-alert>
          </PermissionGate>
          <attach-list-product v-if="store.currentFormDialog === 'list-suppliers'">
          </attach-list-product>
          <form-existence v-if="store.currentForm === 'update-existence'" />
          <form-upload-supplies v-if="store.currentFormDialog === 'form-upload-supplies'" />
          <form-upload-truck v-if="store.currentFormDialog === 'form-upload-trucks'">
          </form-upload-truck>
          <equipment-document-drawer
            v-if="store.currentFormDialog === 'equipment-document-form'"
          />
          <equipment-document-type-manager
            v-if="store.currentFormDialog === 'equipment-document-type-manager'"
          />
          <form-service-provider :showToogle="true" :showCreateCategory="false"
          v-if="store.currentFormDialog === 'form-service-provider'" />
          <form-provider-service-category
          v-if="store.currentFormDialog === 'form-provider-service-category'" />
          <form-coupled v-if="store.currentFormDialog === 'form-truck-coupled'"></form-coupled>
          <form-brand v-if="store.currentFormDialog === 'form-truck-brand'"></form-brand>
          <form-type v-if="store.currentFormDialog === 'form-truck-type'"></form-type>
          <form-filter-alert v-if="store.currentFormDialog === 'form-filter-alert'">
          </form-filter-alert>
          <form-cost-center v-if="store.currentFormDialog === 'form-center-cost'">
          </form-cost-center>
          <PermissionGate permission="maintenance_alerts.categories.create">
            <form-category-alert v-if="store.currentFormDialog === 'form-category-alert'">
            </form-category-alert>
          </PermissionGate>
          <form-filter-range-date v-if="store.currentFormDialog === 'range-date'">
          </form-filter-range-date>
          <form-filter-range-date-supply-by-category v-if="
          store.currentFormDialog === 'range-date-by-supply-category'">
          </form-filter-range-date-supply-by-category>
          <PermissionGate
            :any-of="[
              'inventory.categories.view',
              'inventory.categories.create',
              'inventory.categories.update',
              'inventory.categories.delete',
              'inventory.categories.show',
            ]"
          >
            <form-category-supply
              v-if="store.currentFormDialog === 'form-category-supply'"
            ></form-category-supply>
          </PermissionGate>
          <PermissionGate
            :any-of="[
              'specialists.types.view',
              'specialists.types.create',
              'specialists.types.update',
              'specialists.types.delete',
            ]"
          >
            <form-specialist-type v-if="store.currentFormDialog === 'form-specialist-type'" />
          </PermissionGate>
          <form-client-faena
            :showToogle="true"
            v-if="store.currentFormDialog === 'form-client-faena'"
          />
          <client-faena-manager
            v-if="store.currentFormDialog === 'client-faena-manager'"
          />
          <form-rental-contract-equipment
            v-if="store.currentFormDialog === 'form-rental-contract-equipment'"
          />
          <form-rental-contract-document
            v-if="store.currentFormDialog === 'form-rental-contract-document'"
          />
          <form-rental-contract-checklist
            v-if="store.currentFormDialog === 'form-rental-contract-checklist'"
          />
          <rental-checklist-question-manager
            v-if="store.currentFormDialog === 'rental-checklist-question-manager'"
          />
          <form-rental-delivery-checklist-answer
            v-if="store.currentFormDialog === 'form-rental-delivery-checklist-answer'"
          />
          <rental-contract-quick-view
            v-if="store.currentFormDialog === 'rental-contract-quick-view'"
          />
        </template>
      </container-drawer>

      <!-- General modal dialog  -->
      <general-dialog>

        <template #container-form>
          <form-transaction v-if="store.currentFormDialog === 'form-warehouse-entry'" />
          <form-purchase-order v-if="store.currentFormDialog === 'form-purchase-order'" />
        </template>

        <template #content>
          <table-supplies-selected></table-supplies-selected>
        </template>

        <template #container>
          <container-drawer>
            <template #container>
              <form-select-supply-purchase-order></form-select-supply-purchase-order>
            </template>
          </container-drawer>
        </template>
      </general-dialog>
    </v-app>
</template>

<script>
import { useAppStore } from '@/store/app';

export default {
  components: {
    SettingsModal: () => import('./components/settings/SettingsModal.vue'),
    NotificationsDrawer: () => import('./notifications/components/NotificationsDrawer.vue'),
    DrawerFilterRight: () => import('./components/DrawerFilterRight.vue'),
    UploadStatusPanel: () => import('./components/UploadStatusPanel.vue'),
    ContainerDrawer: () => import('./components/ContainerDrawer.vue'),
    GeneralDialog: () => import('@/components/GeneralDialog.vue'),
    AttachListProduct: () => import('./warehouse/components/AttachListProduct.vue'),
    FormPurchaseOrder: () => import('./warehouse/components/FormPurchaseOrder.vue'),
    FormSelectSupplyPurchaseOrder: () => import('./warehouse/components/FormSelectSupplyPurchaseOrder.vue'),
    TableSuppliesSelected: () => import('./warehouse/components/TableSuppliesSelected.vue'),
    FormTransaction: () => import('./warehouse/components/FormTransaction.vue'),
    FormExistence: () => import('./warehouse/components/FormExistence.vue'),
    FormUploadSupplies: () => import('./inventory/views/FormUploadSupplies.vue'),
    FormServiceProvider: () => import('./provider/components/FormServiceProvider.vue'),
    FormProviderServiceCategory: () => import('./provider/components/FormProviderServiceCategory.vue'),
    FormCoupled: () => import('./trucks/components/FormCoupled.vue'),
    FormBrand: () => import('./trucks/components/FormBrand.vue'),
    FormType: () => import('./trucks/components/FormType.vue'),
    FormUploadTruck: () => import('./trucks/components/FormUploadTruck.vue'),
    EquipmentDocumentDrawer: () => import('./trucks/components/EquipmentDocumentDrawer.vue'),
    EquipmentDocumentTypeManager: () => import('./trucks/components/EquipmentDocumentTypeManager.vue'),
    SideBarCreateAlert: () => import('./maintenance-alerts/components/SideBarCreateAlert.vue'),
    FormFilterAlert: () => import('@/maintenance-alerts/components/FormFilterAlerts.vue'),
    FormCostCenter: () => import('./trucks/components/FormCostCenter.vue'),
    FormCategoryAlert: () => import('./maintenance-alerts/components/FormCategoryAlert.vue'),
    FormFilterRangeDate: () => import('@/reports/views/FormFilterRangeDate.vue'),
    FormFilterRangeDateSupplyByCategory: () => import('./reports/views/FormFilterRangeDateSupplyByCategory.vue'),
    FormCategorySupply: () => import('./inventory/components/FormCategorySupply.vue'),
    FormSpecialistType: () => import('./specialists/components/FormSpecialistType.vue'),
    FormClientFaena: () => import('./clients/components/FormClientFaena.vue'),
    ClientFaenaManager: () => import('./clients/components/ClientFaenaManager.vue'),
    FormRentalContractEquipment: () => import('./rental_contracts/components/FormRentalContractEquipment.vue'),
    FormRentalContractDocument: () => import('./rental_contracts/components/FormRentalContractDocument.vue'),
    FormRentalContractChecklist: () => import('./rental_contracts/components/FormRentalContractChecklist.vue'),
    RentalChecklistQuestionManager: () => import('./rental_contracts/components/RentalChecklistQuestionManager.vue'),
    FormRentalDeliveryChecklistAnswer: () => import('./rental_contracts/components/FormRentalDeliveryChecklistAnswer.vue'),
    RentalContractQuickView: () => import('./rental_contracts/components/RentalContractQuickView.vue'),
  },
  data: () => ({
    store: useAppStore(),
  }),
  async mounted() {
    this.handleNetworkStatus();
    window.addEventListener('online', this.handleNetworkStatus);
    window.addEventListener('offline', this.handleNetworkStatus);
    window.addEventListener('app-snackbar', this.handleApiSnackbar);
    window.addEventListener('app-navigation', this.handleAppNavigation);
  },
  beforeDestroy() {
    window.removeEventListener('online', this.handleNetworkStatus);
    window.removeEventListener('offline', this.handleNetworkStatus);
    window.removeEventListener('app-snackbar', this.handleApiSnackbar);
    window.removeEventListener('app-navigation', this.handleAppNavigation);
  },
  methods: {
    handleApiSnackbar(event) {
      const { message, options } = event.detail || {};
      if (message) this.store.openSnackbar(message, options || {});
    },
    handleAppNavigation(event) {
      const { path } = event.detail || {};
      if (path && this.$route.path !== path) {
        this.$router.replace({ path }).catch(() => {});
      }
    },
    handleNetworkStatus() {
      if (!navigator.onLine) {
        this.store.openSnackbar('No hay conexión a internet', {
          icon: 'mdi-wifi-off',
          color: 'black',
          bottom: true,
          timeout: 0,
          persistent: true,
          source: 'network',
        });
        return;
      }

      if (this.store.snackbar.source === 'network') {
        this.store.snackbar.visible = false;
      }
    },
  },
};
</script>

<style>

</style>

<style >
html,
body,
#app {
  height: 100%;
  overflow: hidden !important;
}

.v-application {
  height: 100vh;
  overflow: hidden !important;
}

.theme--dark.v-application {
    background: #242424 !important;
    color: #fff;
}

.v-dialog.v-dialog--active.v-dialog--persistent.v-dialog--fullscreen {
  overflow: hidden !important;
}

.app {
  overflow: hidden !important;
  overflow-x: hidden !important;
  overflow-y: hidden !important;
}
@import "~ag-grid-community/styles/ag-grid.css";
@import "~ag-grid-community/styles/ag-theme-material.css";
@import "@/styles/ots-board.css";

</style>
